var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-message alert",class:_vm.alertClass},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),(_vm.closable)?_c('button',{staticClass:"btn close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.removeNotification(0)}}},[_c('span',[_vm._v("×")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }